/////////////////////////////
/// General
/////////////////////////////

export enum CampaignOverviewStatus {
  active = 'active',
  inactive = 'inactive',
}
